module.exports = "/static/assets/f5a1783b7dc2aeac29c16cca5c683300.png";